import { Box, makeStyles } from "@material-ui/core";
import * as React from "react";

import theme from "@/theme";

const useStyles = makeStyles(() => ({
  page: { padding: "32px 0", display: "flex", flexDirection: "column", gap: 24 },
  columns: {
    display: "grid",
    gridTemplateColumns: "384px minmax(0,1fr)",
    gap: 40,
    [theme.breakpoints.between("md", "md")]: { gridTemplateColumns: "300px minmax(0,1fr)", gap: 24 },
  },
  panel: {
    backgroundColor: theme.palette.semantic["surface/card"],
    borderRadius: 16,
    padding: 24,
    display: "flex",
    flexDirection: "column",
    gap: 12,
  },
  body: { display: "flex", flexDirection: "column", gap: 32 },
  block: { height: 16, borderRadius: 4, backgroundColor: theme.palette.semantic["field/bg"] },
  avatar: { width: 96, height: 96, borderRadius: "50%", backgroundColor: theme.palette.semantic["field/bg"] },
}));
export const PlannerDetailSkeleton: React.FC = () => {
  const classes = useStyles();
  return (
    <Box className={classes.page} role="status" aria-label="読み込んでいます" data-testid="planner-detail-skeleton">
      <Box className={classes.block} width={160} height={28} />
      <Box className={classes.block} width={140} />
      <Box className={classes.columns}>
        <Box className={classes.panel} alignSelf="start">
          <Box className={classes.avatar} />
          <Box className={classes.block} />
          <Box className={classes.block} width="70%" />
          <Box className={classes.block} width="50%" />
        </Box>
        <Box className={classes.body}>
          {[1, 2, 3].map((id) => (
            <Box key={id} className={classes.panel}>
              <Box className={classes.block} width={120} />
              <Box className={classes.block} height={id === 2 ? 200 : 24} />
              <Box className={classes.block} />
              <Box className={classes.block} width="40%" />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};
